<template>
  <span
    :is="component"
    class="font-bold rounded-md px-2 flex flex-row gap-1 items-center border-2"
    :class="{
      [bgClass]: true,
      [hoverClass]: hoverable,
      [textColor]: true,
      [borderColor]: true,
      blink: flashing,
    }"
    v-bind="$attrs"
    :title="title"
    v-on="$listeners"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: "JoszakiPill",
  props: {
    type: {
      type: String,
      default: "primary",
      validator: function (value) {
        return [
          "default",
          "info",
          "primary",
          "success",
          "warning",
          "danger",
          "error",
          "rating",
        ].includes(value);
      },
    },
    inverted: {
      type: Boolean,
      default: false,
    },
    component: {
      type: String,
      default: "span",
    },
    hoverable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    flashing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bgClass() {
      if (this.inverted) {
        return "bg-white dark:bg-gray-800";
      }
      if (this.type === "default") {
        return "bg-gray-400";
      }

      return `bg-${this.type}`;
    },
    borderColor() {
      if (this.type === "default") {
        return "border-gray-400";
      }
      return `border-${this.type}`;
    },
    textColor() {
      if (this.inverted) {
        return `!text-${this.type}`;
      }

      return "!text-white";
    },
    hoverClass() {
      if (!this.hoverable) {
        return "";
      }

      if (this.type === "default") {
        return this.inverted ? "hover:bg-gray-300" : "hover:bg-gray-700";
      }

      const colorShade = this.inverted ? "lightest" : "darker";

      return `hover:bg-${this.type}-${colorShade}`;
    },
  },
};
</script>
